import Component from '../abstracts/Component';
import queryString from 'query-string';
import TrackingComponent from '../components/TrackingComponent';

export default class NewsletterLogic extends Component {

  constructor(compEl) {
    super(compEl);
    this.$subscribeToNewsletter = this.subscribeToNewsletter;
    this.TrackingComponent = new TrackingComponent();
  }

  // subscribe function
  subscribeToNewsletter(e) {

    let correctEmail = false;
    let privacyChecked = false;
    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // ctx is the new this global
    let ctx = e.event.data;
    
    // preventing submitting form
    e.event.preventDefault();
    // vars
    let $this = e.event.target; // form
    let url = e.event.target.getAttribute('action'); // form url
    let btn = ctx.$component.querySelector(ctx.SELECTORS.submitButton);
    let privacyCheckbox = ctx.$component.querySelector(ctx.SELECTORS.privacyCheckbox);
    let input = ctx.$component.querySelector(ctx.SELECTORS.input);
    let emailInput = ctx.$component.querySelector(ctx.SELECTORS.emailInput);
    let inputBox = ctx.$component.querySelector(ctx.SELECTORS.inputBox);
    let label = ctx.$component.querySelector(ctx.SELECTORS.label);
    let params = new URLSearchParams(new FormData($this)).toString();
    let newsletterBox = ctx.$component;
    let eventsName = ctx.$component.dataset.jsEvents;
    let $submit = ctx.$component.querySelector(ctx.SELECTORS.submitButton);
    let formWrapper = ctx.$component.querySelector(ctx.SELECTORS.formWrapper);
    let errorSubscribed = ctx.$component.querySelector(ctx.SELECTORS.errorSubscribed);
    let errorEmail = ctx.$component.querySelector(ctx.SELECTORS.errorEmail);
    let errorGeneric = ctx.$component.querySelector(ctx.SELECTORS.errorGeneric);
    // btn loading
    btn.classList.add('button--loading');
    btn.disabled = true;
    // modal mode
    /*if ($this.closest('.modal').length) {
      url = url + '?xhr=true';
    }*/
    // adding loading class
    // newsletterBox.classList.add('loading');
    // show spinner loader
    // ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
    //   button: btn,
    // });

    // Remove errors from page
    errorSubscribed.classList.remove('show');
    errorEmail.classList.remove('show');
    errorGeneric.classList.remove('show');
    formWrapper && formWrapper.classList.remove('email-error');

    // Check regex expression for email input
    if (emailInput && !emailRegex.test(emailInput.value)) {
        formWrapper && formWrapper.classList.add('email-error');
        errorEmail.classList.add('show');
    } else {
        formWrapper && formWrapper.classList.remove('email-error');
        errorEmail.classList.remove('show');
        correctEmail = true;
    }

    // Check privacy flag
    if (!privacyCheckbox.checked) {
        privacyCheckbox.parentElement.classList.add('checkbox-error');
    } else {
        privacyChecked = true;
        privacyCheckbox.parentElement.classList.remove('checkbox-error');
    }

    // Do ajax call
    if(privacyChecked){
        ctx.$doAjax({
            type: 'POST',
            url: url,
            data: params
        })
        .done(res => {
            ctx.log('Newsletter modal going...');
            let html = new DOMParser ().parseFromString(res, 'text/html');
            // btn reset
            btn.classList.remove('button--loading');
            btn.disabled = false;
            
            // Searching errors
            let alreadySubcribed = (html.querySelector('div.form-error-userAlreadySubscribed') !== null);
            let subscriptionError = (html.querySelector('div.form-error-subscriptionError') !== null);
            let genericErrorMessage = (html.querySelector('div.form-error-genericErrorMessage') !== null);
            let privacyError = (html.querySelector('div.form-error-privacyError') !== null);

            // Showing errors
            if (privacyError){
                privacyCheckbox.parentElement.classList.add('checkbox-error');
                ctx.$emit(ctx.$customEvents[eventsName].error, {box: newsletterBox ,html: html});
            } else if (alreadySubcribed) {
                formWrapper && formWrapper.classList.add('email-error');
                errorSubscribed.classList.add('show');
                ctx.$emit(ctx.$customEvents[eventsName].error, {box: newsletterBox ,html: html});
            } else if (subscriptionError) {
                formWrapper && formWrapper.classList.add('email-error');
                errorEmail.classList.add('show');
                ctx.$emit(ctx.$customEvents[eventsName].error, {box: newsletterBox ,html: html});
            } else if (genericErrorMessage) {
                formWrapper && formWrapper.classList.add('email-error');
                errorGeneric.classList.add('show');
                ctx.$emit(ctx.$customEvents[eventsName].error, {box: newsletterBox ,html: html});
            } else {
                // SUCCESS
                ctx.log('Newsletter modal success');
                // Emit event
                ctx.$emit(ctx.$customEvents[eventsName].subscribed, {box: newsletterBox});
                let trackingComponent = new TrackingComponent();
                trackingComponent.trackAction('newsletterSubscribe', $submit.dataset , $submit);
            }
        })
        .fail(xhr => {
            console.log(`nl submit error:  ${$(this).serialize()}`);
            console.log(xhr);
        })
        .always(() => {
            // hide spinner loader
            ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {
            button: btn,
            });
        });
    }
    //   newsletter classlist add errore
  }

  afterSubscription(component) {
    component.newsletterWrapper.style.display = "none";
    component.newslettersuccess.style.display = "flex";
  }

  sendFromFooter(component) {
    component.newsletterWrapper.style.display = "none";
    component.newslettersuccess.style.display = "flex";

  }

  render() {
    this.log('Load logics...');
  }
}
